
AccountsController.$inject = ['$scope', 'AlertingFactory', 'DropdownItemsFactory', 'TopToolbarFactory',
  '$translate', '$state', 'company', 'sites', 'sitesMap', 'AccountsFactory', '$mdDialog', 'siteGroups', 'SitesGroupFactory', 'siteGroupsMap', 'StrategiesFactory', 'AngularStringSearchService', 'UserFactory', 'ConfirmationFactory'];
export function AccountsController($scope, AlertingFactory, DropdownItemsFactory, TopToolbarFactory,
  $translate, $state, company, sites, sitesMap, AccountsFactory, $mdDialog, siteGroups, SitesGroupFactory, siteGroupsMap, StrategiesFactory, AngularStringSearchService, UserFactory, ConfirmationFactory) {
  $scope.selectedIndex = $state.params.selectedTabIndex ? $state.params.selectedTabIndex : 0;
  $scope.company = company;
  $scope.hrefAccountInfo = hrefAccountInfo;
  $scope.hrefGroupInfo = hrefGroupInfo;
  $scope.isSiteGroupEmpty = isSiteGroupEmpty;
  $scope.deleteEmptyGroup = deleteEmptyGroup;

  $scope.loggedUserLang = UserFactory.getLoggedUser().lang;
  $scope.allSiteTypes = {}
  StrategiesFactory.getAll().forEach(s => $scope.allSiteTypes[s.getType()] = $translate.instant('account_type/' + s.getTypeString()));



  function filterAccountsAndGroups() {
    $scope.filteredAccounts = $scope.allAccounts.filter(account => doesMatchAccountFilter(account));
    $scope.filteredGroups = siteGroups.filter(group => doesMatchGroupFilter(group));
  }

  function doesMatchGroupFilter(group) {
    return inputMatch(group.name, $scope.groupSearchInput) &&
      platformMatch(group.type, $scope.groupPlatformFilter);
  }
  function doesMatchAccountFilter(account) {
    return inputMatch(account.stringForSearch, $scope.accountSearchInput) &&
      platformMatch(account.type, $scope.accountPlatformFilter);
  }
  function inputMatch(a, b) {
    const aa = AngularStringSearchService.removeDiacriticsThenLowerCase(a, $scope.loggedUserLang);
    const bb = AngularStringSearchService.removeDiacriticsThenLowerCase(b, $scope.loggedUserLang);
    return aa.includes(bb);
  }
  function platformMatch(element, input) {
    if (!input.length) {
      return true;
    }
    return input.indexOf(element) !== -1;
  }

  function redirectToAddAccount() {
    AccountsFactory.redirectToAddAccount($state);
  }

  function addGroup() {
    $mdDialog.show({
      'controller': 'SiteGroupCreationController',
      'template': require('../site-groups/site-group-creation.dialog.html'),
      'targetEvent': event,
      'clickOutsideToClose': false,
      'locals': {
      }
    }).then(function (siteGroup) {
      SitesGroupFactory.createSiteGroup(company.id, siteGroup.name, siteGroup.type)
        .then(
          () => siteGroups.refresh().then(() => {
            siteGroupsMap.refresh();
            sites.refresh().then(() => {
              sitesMap.refresh();
              filterAccountsAndGroups();
            });
          }),
          AlertingFactory.httpErrorHandler()
        )
    });
  }

  function hrefAccountInfo(accountId) {
    return AccountsFactory.hrefAccountInfo($state, accountId);
  }

  function hrefGroupInfo(siteGroupId) {
    return SitesGroupFactory.hrefGroupInfo(siteGroupId);
  }

  function isSiteGroupEmpty(siteGroup) {
    return !Object.keys(siteGroup.sites).length;
  }

  function deleteEmptyGroup(siteGroup) {
    ConfirmationFactory.materialConfirmDialog('parameters/group-account/confirm-group-deletion')
      .then(() => {
        SitesGroupFactory.deleteEmptyGroup(company.id, siteGroup.id).then(
          () => siteGroups.refresh().then(() => {
            siteGroupsMap.refresh();
            sites.refresh().then(() => {
              sitesMap.refresh();
              filterAccountsAndGroups();
            });
          }),
          AlertingFactory.httpErrorHandler()
        );
      })
  }

  init();

  function init() {
    TopToolbarFactory.setTitleTranslation('parameters/links_menu/accounts', $scope);
    TopToolbarFactory.setButton('menu/settings/add-account', redirectToAddAccount, $scope);

    // Filters
    $scope.searchLabel = $translate.instant('accounts/name');
    $scope.platformsKey = 'accounts-field-platform-for-company-' + company.id;
    $scope.platformsLabel = $translate.instant('accounts/platforms');

    // Account table labels
    $scope.accountHeaders = {
      connectionStatus: $translate.instant('accounts/connection_status'),
      platform: $translate.instant('accounts/platforms'),
      accountName: $translate.instant('accounts/name'),
      testLink: $translate.instant('accounts/test_link'),
      siteGroup: $translate.instant('accounts/group')
    };
    // Group table labels
    $scope.groupHeaders = {
      platform: $translate.instant('groups/platform'),
      groupName: $translate.instant('groups/name'),
      accounts: $translate.instant('groups/accounts')
    };

    // Default table order 
    $scope.tableConf = { sortColumn: 'name' };

    // For pagination
    $scope.query = {
      page: 1,
      limit: 10,
      limitOptions: [5, 10, 15, 20]
    };

    $scope.allPlatforms = DropdownItemsFactory.buildChannelItems(sites).map((obj) => ({
      id: obj.id,
      label: obj.label
    }));

    $scope.accountsById = sites.reduce((prev, current, index) => { prev[current.id] = current; return prev; }, {})

    $scope.allAccounts = sites.filter(site => site.id);

    $scope.allAccounts.forEach(account => {
      account.platformLabel = $translate.instant('account_type/' + account.type_name);
      // The prop `site_group` is deprecated and will be replaced by `site_group_id`.
      const siteGroupId = account.site_group_id || account.site_group?.id;
      account.siteGroupLabel = siteGroupsMap.has(siteGroupId) ? siteGroupsMap.get(siteGroupId).name : $translate.instant('none');
      account.platform = account.type;
      account.stringForSearch = AngularStringSearchService.removeDiacriticsThenLowerCase(account.name, $scope.loggedUserLang);
    });

    $scope.allGroupPlatforms = StrategiesFactory.getAll()
      .map((strategy) => ({
        id: strategy.getType(),
        label: $translate.instant('account_type/' + strategy.getTypeString())
      }));
    // Sort them by name 
    $scope.allAccounts.sort((x, y) => {
      if (x.name.toLowerCase() < y.name.toLowerCase()) {
        return -1;
      }
      if (x.name.toLowerCase() > y.name.toLowerCase()) {
        return 1;
      }
      return 0;
    });



    $scope.accountSearchInput = '';
    $scope.accountPlatformFilter = [];
    $scope.groupSearchInput = '';
    $scope.groupPlatformFilter = [];
    $scope.siteGroupAccounts = {};

    siteGroups.forEach(siteGroup => {
      const minimumSitesToShow = 2;
      const sitesIds = Object.keys(siteGroup.sites) || [];
      const firstSites = sitesIds.slice(0, minimumSitesToShow).map(id => siteGroup.sites[id]);
      const siteListMoreNumber = sitesIds.length - minimumSitesToShow;
      $scope.siteGroupAccounts[siteGroup.id] = {
        sitesList: firstSites,
        sitesListMore: sitesIds.length > minimumSitesToShow ? `+ ${siteListMoreNumber} ${$translate.instant(siteListMoreNumber === 1 ? 'other' : 'others')}` : ''
      };
    });

    filterAccountsAndGroups();
  }

  // Filter accounts/groups on filter change
  ['accountSearchInput', 'accountPlatformFilter', 'groupSearchInput', 'groupPlatformFilter'].forEach(field => {
    $scope.$watch(field, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        filterAccountsAndGroups();
      }
    }, true);
  });

  $scope.$watch('selectedIndex', () => {
    // Set top right btn or btns depending on the selected tab
    if ($scope.selectedIndex === 0) {
      $scope.searchLabel = $translate.instant('accounts/name');
      TopToolbarFactory.setTitleTranslation('parameters/links_menu/accounts', $scope);
      TopToolbarFactory.setButton('menu/settings/add-account', redirectToAddAccount, $scope);

    } else if ($scope.selectedIndex === 1) {
      $scope.searchLabel = $translate.instant('groups/name');
      TopToolbarFactory.setTitleTranslation('parameters/links_menu/groups', $scope);
      TopToolbarFactory.setButton('menu/settings/add-group', addGroup, $scope);
    }
  });

  const selectedChannel = $state.params.channel;
  if (selectedChannel) {
    const platformQueryParamsMatches = ($scope.allPlatforms || []).some(({ id }) => `${id}` === `${selectedChannel}`);
    if (platformQueryParamsMatches) {
      $scope.accountPlatformFilter = [+selectedChannel];
    }
  }
}
